/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Unknown_UserInputs */

const th_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบบัญชีที่ใช้อีเมลนี้`)
};

const en_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No account has that email address.`)
};

const ja_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`そのメールアドレスのアカウントはありません。`)
};

const zh_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有账户使用该邮箱地址。`)
};

const es_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguna cuenta tiene esa dirección de correo.`)
};

const pt_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma conta tem esse endereço de e-mail.`)
};

const id_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada akun dengan alamat email itu.`)
};

const fr_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun compte n’a cette adresse e-mail.`)
};

const tl_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang account na may ganoong email address.`)
};

const vi_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tài khoản nào dùng địa chỉ email đó.`)
};

const ko_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그 이메일 주소를 쓰는 계정이 없습니다.`)
};

const de_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Konto hat diese E-Mail-Adresse.`)
};

const ru_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ни один аккаунт не использует этот адрес почты.`)
};

const tr_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu e-posta adresini kullanan bir hesap yok.`)
};

const it_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun account usa quell'indirizzo email.`)
};

const pl_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Żadne konto nie używa tego adresu e-mail.`)
};

const uk_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жоден обліковий запис не використовує цю адресу пошти.`)
};

const hi_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उस ईमेल पते वाला कोई खाता नहीं है।`)
};

const ar_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يوجد حساب بهذا البريد الإلكتروني.`)
};

const ms_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada akaun menggunakan alamat e-mel itu.`)
};

const bn_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওই ইমেল ঠিকানার কোনও অ্যাকাউন্ট নেই।`)
};

const zh_tw2_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有帳戶使用該電子郵件位址。`)
};

const zh_hk2_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有帳戶使用該電子郵件位址。`)
};

const ur_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس ای میل پتے والا کوئی اکاؤنٹ نہیں۔`)
};

const fa_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هیچ حسابی با آن نشانی ایمیل نیست.`)
};

const sw_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna akaunti inayotumia anwani hiyo ya barua pepe.`)
};

const nl_err_unknown_user = /** @type {(inputs: Err_Unknown_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen enkel account gebruikt dat e-mailadres.`)
};

/**
* | output |
* | --- |
* | "No account has that email address." |
*
* @param {Err_Unknown_UserInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_unknown_user = /** @type {((inputs?: Err_Unknown_UserInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Unknown_UserInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_unknown_user(inputs)
	if (locale === "ja") return ja_err_unknown_user(inputs)
	if (locale === "zh") return zh_err_unknown_user(inputs)
	if (locale === "es") return es_err_unknown_user(inputs)
	if (locale === "pt") return pt_err_unknown_user(inputs)
	if (locale === "id") return id_err_unknown_user(inputs)
	if (locale === "fr") return fr_err_unknown_user(inputs)
	if (locale === "tl") return tl_err_unknown_user(inputs)
	if (locale === "vi") return vi_err_unknown_user(inputs)
	if (locale === "ko") return ko_err_unknown_user(inputs)
	if (locale === "de") return de_err_unknown_user(inputs)
	if (locale === "ru") return ru_err_unknown_user(inputs)
	if (locale === "tr") return tr_err_unknown_user(inputs)
	if (locale === "it") return it_err_unknown_user(inputs)
	if (locale === "pl") return pl_err_unknown_user(inputs)
	if (locale === "uk") return uk_err_unknown_user(inputs)
	if (locale === "hi") return hi_err_unknown_user(inputs)
	if (locale === "ar") return ar_err_unknown_user(inputs)
	if (locale === "ms") return ms_err_unknown_user(inputs)
	if (locale === "bn") return bn_err_unknown_user(inputs)
	if (locale === "zh-TW") return zh_tw2_err_unknown_user(inputs)
	if (locale === "zh-HK") return zh_hk2_err_unknown_user(inputs)
	if (locale === "ur") return ur_err_unknown_user(inputs)
	if (locale === "fa") return fa_err_unknown_user(inputs)
	if (locale === "sw") return sw_err_unknown_user(inputs)
	if (locale === "nl") return nl_err_unknown_user(inputs)
	return en_err_unknown_user(inputs)
});